import axios from "axios";
import { apiUrl } from "src/config/api";
export const checkUserStatusAndRedirect = async () => {
  try {
    // Fetch user data from the "user" endpoint
    const res: any = await axios.get(apiUrl("/user"));
    if (!res) {
      console.error("User data is undefined or null.");
      return;
    }
    console.log("USER RESPONSE from common ===>", res);

    // Fetch user status from the "/school/users/464" endpoint
    const res2: any = await axios.get(apiUrl(`/school/users/${res?.data?.id}`));
    if (!res2) {
      console.error("User status data is undefined or null.");
      return;
    }

    // If status is true, redirect to /logout
    if (res2?.data?.user?.status === false) {
     
      await axios.post(apiUrl("/logout"));
        window.location.href = "/logout";
        console.log("logged out sucessfully.")
    }
  } catch (error) {
    console.error("Error occurred during the API calls:", error);
  }
};



// WEBPACK FOOTER //
// ./src/services/commonLogout.ts